import LoginView from 'components/Auth/LoginView';

const LoginPage = () => {
  return <LoginView />;
};

export default LoginPage;
